import '@fontsource/roboto';
import { createUseStyles } from 'react-jss';

export default createUseStyles({
  '@global': {
    body: {
      margin: 0,
      padding: 0,
      fontFamily:
        '-apple-system, BlinkMacSystemFont, ' +
        "'Segoe UI', 'Roboto', 'Oxygen'," +
        "'Ubuntu', 'Cantarell', 'Fira Sans', " +
        "'Droid Sans', 'Helvetica Neue', sans-serif",
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
      overflow: 'hidden',
    },
  },
});
